import React, { useCallback, useState } from 'react';
import { FilterChips } from '../components/whatsnew/FilterChips';
import { ResourceCard } from '../components/guides/ResourceCard';
import { DownloadModal } from '../components/guides/DownloadModal';
import { CtaBand } from '../components/company/CtaBand';
import { resourceFilters, resources } from '../data/guides';
import type { Resource } from '../types/article';
type Filter = (typeof resourceFilters)[number];
export function Guides() {
  const [filter, setFilter] = useState<Filter>('All');
  const [active, setActive] = useState<Resource | null>(null);
  const close = useCallback(() => setActive(null), []);
  const shown = filter === 'All' ? resources : resources.filter(r => `${r.type}s` === filter);
  return <main data-id="element-2051" data-mp="2kjueib7x86nn">
      <section className="hero-surface w-full" aria-labelledby="guides-heading" data-id="element-2052" data-mp="2khhxc09zm0bn">
        <div className="mx-auto max-w-shell px-6 pb-14 pt-14 lg:pb-16 lg:pt-20" data-id="element-2053" data-mp="25n3pmvvvidca">
          <div className="max-w-[760px]" data-id="element-2054" data-mp="2ak3lkdz0dzpo">
            <h1 id="guides-heading" className="display text-[38px] font-semibold text-ink sm:text-[50px] lg:text-[56px]" data-id="element-2055" data-mp="2an9czzv41dok">
              Free guides and templates for your business
            </h1>
            <p className="mt-5 max-w-[580px] text-[18px] leading-[1.5] text-ink-soft" data-id="element-2056" data-mp="75zg30mxlwg3">
              Ready-to-use tools to manage stock, cash and customers, even before you use Kayko.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full bg-white py-14 lg:py-16" aria-label="Resources" data-id="element-2057" data-mp="3pinwa1p9ved0">
        <div className="mx-auto max-w-shell px-6" data-id="element-2058" data-mp="3kj1i9q1mdu35">
          <div className="md:[&>div]:justify-start" data-id="element-2059" data-mp="3kkcjpj7lepr3">
            <FilterChips options={resourceFilters} value={filter} onChange={setFilter} ariaLabel="Filter resources by type" data-id="element-2060" data-mp="24s9v60ft5bj" />
          </div>
          <ul className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-2061" data-mp="3thwqt8s4zg9m">
            {shown.map(r => <li key={r.id} data-id="element-2062" data-mp="35r94hihh4o3j">
                <ResourceCard resource={r} onDownload={setActive} data-id="element-2063" data-mp="31sjqposix4jd" />
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBand headline="Ready to leave spreadsheets behind?" subheadline="Kayko does the maths for you: sales, stock, and profit update as you work." primary={{
      label: 'Get started',
      href: '/get-started'
    }} secondary={{
      label: 'Book a demo',
      href: '/demo'
    }} data-id="element-2064" data-mp="14r46zrxil52e" />

      <DownloadModal resource={active} onClose={close} data-id="element-2065" data-mp="1jfii0q533zu1" />
    </main>;
}